// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1y64M","rootSuccess":"CompleteLink_rootSuccess__1fIKV","rootFailure":"CompleteLink_rootFailure__1ZJ5j","isDisabled":"CompleteLink_isDisabled__3NIgn"};